module.exports = __webpack_public_path__ + "static/media/ftp.0f4a2178.png";